"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Alert = _interopRequireDefault(require("../../../Icons/Alert"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-danger */
var ErrorMessages = function ErrorMessages(_ref) {
  var errorMessages = _ref.errorMessages;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "form-control__error-messages",
    "data-testid": "errorMessages"
  }, errorMessages.map(function (errorMessage) {
    return /*#__PURE__*/_react.default.createElement("p", {
      className: "form-control__error-message",
      key: errorMessage
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "form-control__error-icon",
      "aria-hidden": "true"
    }, /*#__PURE__*/_react.default.createElement(_Alert.default, null)), /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: errorMessage
      }
    }));
  }));
};

ErrorMessages.propTypes = {
  /**
   Required. Array of error message strings.
   */
  errorMessages: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
};
var _default = ErrorMessages;
exports.default = _default;